<span class="snackbar">
  <ng-container *ngIf="!data?.text; else textBlock">{{ data?.title! | translate }}</ng-container>
  <ng-template #textBlock>{{ data?.text }}</ng-template>
</span>
